var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Lock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.00065 18.334C4.54232 18.334 4.14996 18.1708 3.82357 17.8444C3.49718 17.518 3.33398 17.1257 3.33398 16.6673V8.33398C3.33398 7.87565 3.49718 7.48329 3.82357 7.1569C4.14996 6.83051 4.54232 6.66732 5.00065 6.66732H5.83398V5.00065C5.83398 3.84787 6.24023 2.86523 7.05273 2.05273C7.86523 1.24023 8.84787 0.833984 10.0007 0.833984C11.1534 0.833984 12.1361 1.24023 12.9486 2.05273C13.7611 2.86523 14.1673 3.84787 14.1673 5.00065V6.66732H15.0007C15.459 6.66732 15.8513 6.83051 16.1777 7.1569C16.5041 7.48329 16.6673 7.87565 16.6673 8.33398V16.6673C16.6673 17.1257 16.5041 17.518 16.1777 17.8444C15.8513 18.1708 15.459 18.334 15.0007 18.334H5.00065ZM10.0007 14.1673C10.459 14.1673 10.8513 14.0041 11.1777 13.6777C11.5041 13.3513 11.6673 12.959 11.6673 12.5007C11.6673 12.0423 11.5041 11.65 11.1777 11.3236C10.8513 10.9972 10.459 10.834 10.0007 10.834C9.54232 10.834 9.14996 10.9972 8.82357 11.3236C8.49718 11.65 8.33398 12.0423 8.33398 12.5007C8.33398 12.959 8.49718 13.3513 8.82357 13.6777C9.14996 14.0041 9.54232 14.1673 10.0007 14.1673ZM7.50065 6.66732H12.5007V5.00065C12.5007 4.30621 12.2576 3.71593 11.7715 3.22982C11.2854 2.74371 10.6951 2.50065 10.0007 2.50065C9.30621 2.50065 8.71593 2.74371 8.22982 3.22982C7.74371 3.71593 7.50065 4.30621 7.50065 5.00065V6.66732Z",
    fill: "#CCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIconWhite);
export default __webpack_public_path__ + "static/media/lock-icon-white.971b3791acf83b1c31348166d06c02b9.svg";
export { ForwardRef as ReactComponent };